
import { Fragment } from "react";
import { Message, MessageTone } from "@/types/message";
import LoadingMessage from "./LoadingMessage";
import ThreadTimeline from "./list/ThreadTimeline";
import EmptyState from "./list/EmptyState";
import { useMessageList } from "./list/useMessageList";

interface MessageListProps {
  messages: Message[];
  companyName: string;
  isAIGenerating?: boolean;
  onRegenerateAIResponse?: (messageId: string, tone: MessageTone, customInstructions?: string) => Promise<Message | null>;
  isRegenerating?: boolean;
  regeneratingMessageId?: string;
  orderNumber?: string;
  userEmail?: string; 
  sellerEmail?: string;
}

const MessageList = ({
  messages,
  companyName = "Merchant",
  isAIGenerating = false,
  onRegenerateAIResponse,
  isRegenerating = false,
  regeneratingMessageId,
  orderNumber = "",
  userEmail = "",
  sellerEmail = ""
}: MessageListProps) => {
  // Use our extracted hook to handle message list logic
  const {
    groupedThreads,
    latestAIMessage,
    hasMessages,
    expandedThreads,
    toggleThread
  } = useMessageList({ messages, isAIGenerating });
  
  return (
    <div className="space-y-4">
      {!hasMessages && !isAIGenerating ? (
        <EmptyState />
      ) : (
        <Fragment>
          <ThreadTimeline 
            groupedThreads={groupedThreads}
            companyName={companyName}
            onRegenerateAIResponse={onRegenerateAIResponse}
            isRegenerating={isRegenerating}
            regeneratingMessageId={regeneratingMessageId}
            orderNumber={orderNumber}
            userEmail={userEmail}
            sellerEmail={sellerEmail}
            latestAIMessage={latestAIMessage}
            expandedThreads={expandedThreads}
            toggleThread={toggleThread}
          />
          
          {isAIGenerating && (
            <LoadingMessage>
              <div className="animate-pulse text-sm text-muted-foreground">
                Generating AI response...
              </div>
            </LoadingMessage>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default MessageList;
